'use es6';

import * as client from 'DesignData/api/Ecosystem';
import { ECOSYSTEM_MARKETPLACE_OFFERINGS_RECEIVE } from 'DesignData/actions/ActionTypes';
/**
 * GET ecosystem/v1/offerings/types/2
 */

export function getMarketplaceOfferings() {
  const {
    receive,
    error
  } = getMarketplaceOfferings;
  return dispatch => {
    return client.getMarketplaceOfferings().then(result => {
      dispatch(receive(result));
    }).catch(__error => {
      dispatch(error(__error));
    });
  };
}

getMarketplaceOfferings.receive = result => {
  return {
    type: ECOSYSTEM_MARKETPLACE_OFFERINGS_RECEIVE,
    result
  };
};

getMarketplaceOfferings.error = error => {
  return {
    type: ECOSYSTEM_MARKETPLACE_OFFERINGS_RECEIVE,
    error
  };
};